<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Notifications</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body v-if="notification">
        <b-card-header>
          <h3 class="mb-0">{{ notification.data.subject }}</h3>
        </b-card-header>
        <b-card-body>
          <p><strong>From:</strong> {{ notification.data.from }}</p>
          <p><strong>Message:</strong> <span v-html="notification.data.message"></span></p>
          <b-button variant="danger" :to="notification.data.data.link">View</b-button>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb
  },
  data() {
    return {
      notification: null
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    userSlug() {
      return this.$store.getters['profile/user'].slug;
    }
  },
  methods: {
    async getNotification() {
      await axios.get(this.userRoute + "/notifications/" + this.$route.params.id)
      .then(response => {
        this.notification = response.data;
        this.markAsRead();
        this.$store.dispatch("notifications/get", { user: this.userSlug });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async markAsRead() {
      await axios.post(this.userRoute + "/notifications/mark-as-read", {
        notifications: [this.notification.id]
      })
      .then(response => {
        // 
      })
      .catch(error => {
        this.error(error);
      });
    },
  },
  created() {
    this.getNotification();
  },
  mounted() {
    document.title = "Notification | ClarityNOW";
  }
};
</script>
<style lang="scss">
tr:hover {
  cursor: pointer
}
</style>